(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["workout-article"] && !Shopify.designMode) return;
  try {
    
(function() {
  var downloadButton = document.querySelector('[data-workout-download]');

  function slugify(value) {
    return (value || 'tiger-fitness-workout').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function escapeHtml(value) {
    return String(value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function buildPdfDocument() {
    var source = document.querySelector('.tf-workout');
    var assets = document.querySelector('[data-workout-pdf-assets]');
    if (!source || !assets) return null;
    var title = source.querySelector('h1');
    var summary = source.querySelector('.tf-workout__summary');
    var facts = source.querySelector('.tf-workout__facts');
    var description = source.querySelector('.tf-workout__description');
    var plan = source.querySelector('.tf-workout__plan');
    var pdf = document.createElement('div');
    var titleText = title ? title.textContent.trim() : 'Tiger Fitness Workout';
    pdf.className = 'tf-pdf-document';
    pdf.setAttribute('aria-hidden', 'true');
    pdf.innerHTML = '<style>' +
      '.tf-pdf-document{background:#fff;color:#111;font-family:Arial,sans-serif;width:816px;padding:0;position:absolute;left:-10000px;top:0;z-index:-1}' +
      '.tf-pdf-header{background:#000;color:#fff;display:grid;grid-template-columns:1fr 165px;gap:22px;align-items:center;padding:28px 34px;border-bottom:7px solid #ff4500}' +
      '.tf-pdf-kicker{color:#ffb391;font-size:11px;font-weight:800;letter-spacing:1.4px;margin:0 0 7px;text-transform:uppercase}' +
      '.tf-pdf-header h1{color:#fff;font-size:30px;line-height:1.1;margin:0;text-transform:uppercase}' +
      '.tf-pdf-summary{color:#ececec;font-size:14px;line-height:1.45;margin:10px 0 0}' +
      '.tf-pdf-logo{max-height:118px;max-width:165px;width:100%;object-fit:contain}' +
      '.tf-pdf-body{padding:28px 34px 0}' +
      '.tf-pdf-facts{display:grid;grid-template-columns:repeat(3,1fr);border:1px solid #ddd;margin:0 0 22px}' +
      '.tf-pdf-facts>div{background:#f5f5f5;border-right:1px solid #ddd;min-height:63px;padding:10px 12px}' +
      '.tf-pdf-facts>div:nth-child(3n){border-right:0}.tf-pdf-facts span{color:#666;display:block;font-size:9px;font-weight:800;letter-spacing:.5px;text-transform:uppercase}.tf-pdf-facts strong{color:#111;display:block;font-size:13px;line-height:1.25;margin-top:5px}' +
      '.tf-pdf-content{font-size:13px;line-height:1.52}.tf-pdf-content h2{color:#111;font-size:22px;line-height:1.18;margin:21px 0 12px}.tf-pdf-content h3{background:#000;color:#fff;font-size:17px;margin:24px 0 0;padding:11px 13px;text-transform:uppercase}.tf-pdf-content p{margin:0 0 12px}.tf-pdf-content table{border-collapse:collapse;font-size:12px;margin:12px 0 22px;width:100%}.tf-pdf-content th,.tf-pdf-content td{border:1px solid #d7d7d7;padding:8px 9px;text-align:left}.tf-pdf-content th,.tf-pdf-content tr:first-child td{background:#ff4500;color:#fff;font-size:10px;font-weight:800;letter-spacing:.3px;text-transform:uppercase}.tf-pdf-content tr:nth-child(even) td{background:#f6f6f6}.tf-pdf-content a{color:#111;text-decoration:none}.tf-pdf-content img,.tf-pdf-content iframe,.tf-pdf-content video{display:none!important}.tf-pdf-footer{display:block;margin-top:4px;width:100%}' +
      '</style>' +
      '<header class="tf-pdf-header"><div><p class="tf-pdf-kicker">Tiger Fitness Workouts</p><h1>' + escapeHtml(titleText) + '</h1>' + (summary ? '<div class="tf-pdf-summary">' + summary.innerHTML + '</div>' : '') + '</div><img class="tf-pdf-logo" src="' + assets.dataset.logo + '" alt="Tiger Fitness"></header>' +
      '<main class="tf-pdf-body">' +
      (facts ? '<section class="tf-pdf-facts">' + facts.innerHTML + '</section>' : '') +
      '<section class="tf-pdf-content">' + (description ? description.innerHTML : '') + (plan ? plan.innerHTML : '') + '</section>' +
      '<img class="tf-pdf-footer" src="' + assets.dataset.footer + '" alt="Tiger Fitness — You are more than just a number here">' +
      '</main>';
    return pdf;
  }

  function getFacts() {
    var facts = document.querySelector('.tf-workout__facts');
    if (!facts) return [];
    return Array.prototype.slice.call(facts.querySelectorAll('div')).map(function(item) {
      var label = item.querySelector('span, dt, small');
      var value = item.querySelector('strong, dd, b');
      return { label: label ? label.textContent.trim() : '', value: value ? value.textContent.trim() : item.textContent.trim() };
    }).filter(function(item) { return item.label && item.value; });
  }

  function addWrappedText(doc, text, x, y, width, options) {
    options = options || {};
    doc.setFont('helvetica', options.bold ? 'bold' : 'normal');
    doc.setFontSize(options.size || 10);
    doc.setTextColor.apply(doc, options.color || [17, 17, 17]);
    var lines = doc.splitTextToSize((text || '').replace(/\s+/g, ' ').trim(), width);
    doc.text(lines, x, y, { lineHeightFactor: options.lineHeight || 1.35 });
    return y + lines.length * (options.size || 10) * (options.lineHeight || 1.35) / 2.84;
  }

  function addFooter(doc) {
    var pageHeight = doc.internal.pageSize.getHeight();
    doc.setFillColor(0, 0, 0);
    doc.rect(0, pageHeight - 19, 215.9, 3, 'F');
    doc.setFillColor(255, 69, 0);
    doc.rect(0, pageHeight - 16, 215.9, 11, 'F');
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);
    doc.setTextColor(255, 255, 255);
    doc.text('TIGER FITNESS  |  YOU\'RE MORE THAN JUST A NUMBER HERE', 108, pageHeight - 9, { align: 'center' });
    doc.setFillColor(0, 0, 0);
    doc.rect(0, pageHeight - 5, 215.9, 3, 'F');
  }

  function addHeader(doc, title, subtitle) {
    doc.setFillColor(0, 0, 0);
    doc.rect(0, 0, 215.9, 42, 'F');
    doc.setFillColor(255, 69, 0);
    doc.rect(0, 39, 215.9, 3, 'F');
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    doc.setTextColor(255, 179, 145);
    doc.text('TIGER FITNESS WORKOUTS', 14, 12);
    doc.setFontSize(18);
    doc.setTextColor(255, 255, 255);
    var titleLines = doc.splitTextToSize(title, 145);
    doc.text(titleLines, 14, 21, { lineHeightFactor: 1.08 });
    if (subtitle) {
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8);
      doc.setTextColor(232, 232, 232);
      doc.text(doc.splitTextToSize(subtitle, 145), 14, 33, { lineHeightFactor: 1.2 });
    }
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(14);
    doc.setTextColor(255, 69, 0);
    doc.text('TF', 191, 21, { align: 'center' });
    doc.setFontSize(7);
    doc.setTextColor(255, 255, 255);
    doc.text('TIGER FITNESS', 191, 27, { align: 'center' });
    return 52;
  }

  function appendHeaderFooter(doc, totalPages) {
    for (var page = 1; page <= totalPages; page++) {
      doc.setPage(page);
      addFooter(doc);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(7);
      doc.setTextColor(90, 90, 90);
      doc.text('TigerFitness.com', 14, 289);
      doc.text(String(page) + ' / ' + String(totalPages), 202, 289, { align: 'right' });
    }
  }

  if (downloadButton) downloadButton.addEventListener('click', function() {
    if (!window.jspdf || !window.jspdf.jsPDF) { alert('The workout download is still loading. Please try again in a moment.'); return; }
    var originalText = downloadButton.textContent;
    var title = (document.querySelector('.tf-workout h1') || {}).textContent || 'Tiger Fitness Workout';
    var summary = (document.querySelector('.tf-workout__summary') || {}).textContent || '';
    var doc = new window.jspdf.jsPDF({ unit: 'mm', format: 'letter', orientation: 'portrait', compress: true });
    var y = addHeader(doc, title.trim(), summary.trim());
    downloadButton.disabled = true;
    downloadButton.textContent = 'Preparing PDF…';
    try {
      var facts = getFacts();
      if (facts.length) {
        doc.setFont('helvetica', 'bold'); doc.setFontSize(11); doc.setTextColor(0, 0, 0); doc.text('WORKOUT SUMMARY', 14, y); y += 5;
        var factsRows = [];
        for (var f = 0; f < facts.length; f += 2) factsRows.push([facts[f].label + '\n' + facts[f].value, facts[f + 1] ? facts[f + 1].label + '\n' + facts[f + 1].value : '']);
        doc.autoTable({ startY: y, body: factsRows, theme: 'grid', margin: { left: 14, right: 14 }, styles: { font: 'helvetica', fontSize: 9, cellPadding: 3, textColor: [17,17,17] }, alternateRowStyles: { fillColor: [245,245,245] }, tableLineColor: [220,220,220], tableLineWidth: .2 });
        y = doc.lastAutoTable.finalY + 9;
      }
      function renderNodes(container) {
        if (!container) return;
        Array.prototype.slice.call(container.children).forEach(function(node) {
          var tag = node.tagName.toLowerCase();
          if (node.classList && node.classList.contains('tf-workout-summary')) {
            var summaryRows = Array.prototype.slice.call(node.querySelectorAll('dl > div')).map(function(item) {
              var label = item.querySelector('dt');
              var value = item.querySelector('dd');
              return [label ? label.textContent.replace(/\s+/g, ' ').trim() : '', value ? value.textContent.replace(/\s+/g, ' ').trim() : ''];
            }).filter(function(row) { return row[0] && row[1]; });
            if (summaryRows.length) {
              if (y > 225) { doc.addPage(); y = 18; }
              doc.setFillColor(0, 0, 0); doc.rect(14, y - 5, 187.9, 10, 'F');
              doc.setFont('helvetica', 'bold'); doc.setFontSize(11); doc.setTextColor(255,255,255); doc.text('WORKOUT SUMMARY', 17, y + 1); y += 12;
              doc.autoTable({ startY: y, body: summaryRows, theme: 'grid', margin: { left: 14, right: 14, bottom: 25 }, styles: { font: 'helvetica', fontSize: 9, cellPadding: 2.8, textColor: [17,17,17] }, alternateRowStyles: { fillColor: [246,246,246] }, tableLineColor: [215,215,215], tableLineWidth: .2, columnStyles: { 0: { cellWidth: 70, fontStyle: 'bold' }, 1: { cellWidth: 117 } } });
              y = doc.lastAutoTable.finalY + 8;
            }
          } else if (tag === 'h1' || tag === 'h2' || tag === 'h3' || tag === 'h4') {
            if (y > 250) { doc.addPage(); y = 18; }
            doc.setFillColor(0, 0, 0); doc.rect(14, y - 5, 187.9, 9, 'F');
            doc.setFont('helvetica', 'bold'); doc.setFontSize(11); doc.setTextColor(255,255,255); doc.text(node.textContent.trim(), 17, y + 1); y += 12;
          } else if (tag === 'table') {
            var rows = Array.prototype.slice.call(node.rows).map(function(row) {
              return Array.prototype.slice.call(row.cells).map(function(cell) { return cell.textContent.replace(/\s+/g, ' ').trim(); }).filter(function(cell) { return cell; });
            }).filter(function(cells) { return cells.length; });
            var tableTitle = '', tableSubtitle = '', head = [], body = [];
            if (rows.length && rows[0].length === 1) {
              tableTitle = rows.shift()[0];
              if (rows.length && rows[0].length === 1) tableSubtitle = rows.shift()[0];
            }
            if (tableTitle) {
              if (y > 246) { doc.addPage(); y = 18; }
              doc.setFillColor(0, 0, 0); doc.rect(14, y - 5, 187.9, 10, 'F');
              doc.setFont('helvetica', 'bold'); doc.setFontSize(11); doc.setTextColor(255,255,255); doc.text(tableTitle, 17, y + 1); y += 12;
              if (tableSubtitle) { doc.setFont('helvetica', 'bold'); doc.setFontSize(10); doc.setTextColor(65,65,65); doc.text(tableSubtitle, 14, y); y += 6; }
            }
            if (rows.length && rows[0].length > 1 && rows[0][0].toLowerCase() === 'exercise') head.push(rows.shift());
            body = rows;
            if (body.length) {
              var columnStyles = body[0].length >= 3 ? { 0: { cellWidth: 120 }, 1: { cellWidth: 32, halign: 'center' }, 2: { cellWidth: 35, halign: 'center' } } : { 0: { cellWidth: 70 }, 1: { cellWidth: 117 } };
              doc.autoTable({ startY: y, head: head, body: body, theme: 'grid', margin: { left: 14, right: 14, bottom: 25 }, styles: { font: 'helvetica', fontSize: 9, cellPadding: 2.6, textColor: [17,17,17] }, headStyles: { fillColor: [255,69,0], textColor: [255,255,255], fontStyle: 'bold' }, alternateRowStyles: { fillColor: [246,246,246] }, tableLineColor: [215,215,215], tableLineWidth: .2, columnStyles: columnStyles });
              y = doc.lastAutoTable.finalY + 8;
            }
          } else if (tag === 'p' || tag === 'li') {
            if (y > 250) { doc.addPage(); y = 18; }
            y = addWrappedText(doc, node.textContent, 14, y, 187.9, { size: 10, lineHeight: 1.42 }) + 4;
          } else {
            renderNodes(node);
          }
        });
      }
      renderNodes(document.querySelector('.tf-workout__description'));
      renderNodes(document.querySelector('.tf-workout__plan'));
      appendHeaderFooter(doc, doc.getNumberOfPages());
      doc.save(slugify(title) + '-workout.pdf');
    } catch (error) {
      alert('We could not create this workout PDF. Please try again.');
    }
    downloadButton.disabled = false;
    downloadButton.textContent = originalText;
  });

  document.querySelectorAll('.tf-workout__description table.gainscss').forEach(function(table) {
    var header = table.querySelector('thead th');
    if (!header || header.textContent.trim().toLowerCase() !== 'workout summary') return;
    var summary = document.createElement('section');
    summary.className = 'tf-workout-summary';
    summary.setAttribute('aria-label', 'Workout summary');
    var title = document.createElement('h3');
    title.textContent = header.textContent.trim();
    var list = document.createElement('dl');
    Array.prototype.forEach.call(table.querySelectorAll('tbody tr'), function(row) {
      var cells = row.querySelectorAll('td');
      if (cells.length < 2) return;
      var item = document.createElement('div');
      var label = document.createElement('dt');
      var value = document.createElement('dd');
      label.innerHTML = cells[0].innerHTML;
      value.innerHTML = cells[1].innerHTML;
      item.appendChild(label);
      item.appendChild(value);
      list.appendChild(item);
    });
    summary.appendChild(title);
    summary.appendChild(list);
    var wrapper = table.closest('#workout');
    (wrapper || table).replaceWith(summary);
  });

  document.querySelectorAll('.tf-workout__description #workout table').forEach(function(table) {
    Array.prototype.forEach.call(table.querySelectorAll('th[colspan], td[colspan]'), function(cell) {
      if (parseInt(cell.getAttribute('colspan'), 10) > 3) cell.colSpan = 3;
    });
    var existingColumns = table.querySelector('colgroup');
    if (existingColumns) existingColumns.remove();
    var columns = document.createElement('colgroup');
    ['60%', '20%', '20%'].forEach(function(width) {
      var column = document.createElement('col');
      column.style.width = width;
      columns.appendChild(column);
    });
    table.insertBefore(columns, table.firstChild);
    table.style.tableLayout = 'fixed';
    table.style.width = '100%';
  });

  document.querySelectorAll('.tf-workout__description #workout').forEach(function(workout) {
    Array.prototype.forEach.call(workout.querySelectorAll('table'), function(outerTable) {
      var nestedTable = outerTable.querySelector('td table');
      if (!nestedTable) return;
      var nestedCell = nestedTable.parentElement;
      var totalColumns = 0;
      Array.prototype.forEach.call(outerTable.rows, function(row) { totalColumns = Math.max(totalColumns, row.cells.length); });
      if (totalColumns < 2) return;
      nestedCell.colSpan = totalColumns;
      nestedCell.style.width = '100%';
      Array.prototype.forEach.call(nestedCell.parentElement.cells, function(cell) {
        if (cell !== nestedCell) cell.remove();
      });
      nestedTable.style.width = '100%';
      nestedTable.style.minWidth = '100%';
      nestedTable.style.maxWidth = 'none';
    });
  });

  document.querySelectorAll('.tf-workout__description #workout table').forEach(function(table) {
    Array.prototype.forEach.call(table.rows, function(row) {
      var cells = Array.prototype.slice.call(row.cells);
      if (!cells.length) return;
      Array.prototype.forEach.call(row.querySelectorAll('th[colspan]'), function(header) { header.colSpan = 3; });
      if (cells.length <= 3) return;
      var trailingCells = cells.slice(1);
      var isSectionHeader = cells[0].textContent.trim() && trailingCells.every(function(cell) { return !cell.textContent.trim(); });
      if (isSectionHeader) {
        cells[0].colSpan = 3;
        cells.slice(1).forEach(function(cell) { cell.remove(); });
      } else {
        cells.slice(3).forEach(function(cell) { cell.remove(); });
      }
    });
  });

  document.querySelectorAll('.tf-workout__description table, .tf-workout__exercise-content table').forEach(function(table) {
    Array.prototype.forEach.call(table.rows, function(row, rowIndex) {
      var cells = row.cells;
      if (rowIndex === 0 || cells.length < 3) return;
      var exerciseCell = cells[0];
      if (!exerciseCell || exerciseCell.querySelector('a')) return;
      var exerciseName = exerciseCell.textContent.trim();
      if (!exerciseName || /^(exercise|sets|reps)$/i.test(exerciseName) || /choose any|optional|rest day/i.test(exerciseName)) return;
      var handle = exerciseName.toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      if (!handle) return;
      var link = document.createElement('a');
      link.href = '/blogs/exercise-database/' + handle;
      link.textContent = exerciseName;
      link.setAttribute('data-exercise-link', 'true');
      exerciseCell.textContent = '';
      exerciseCell.appendChild(link);
    });
  });


  (function() {
    var button = document.querySelector('[data-workout-download-v2]');
    if (!button) return;

    function clean(value) { return (value || '').replace(/\s+/g, ' ').trim(); }
    function slugify(value) { return clean(value).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'tiger-fitness-workout'; }
    function getFactRows() {
      var rows = Array.prototype.slice.call(document.querySelectorAll('.tf-workout-summary dl > div')).map(function(row) {
        var label = row.querySelector('dt');
        var value = row.querySelector('dd');
        return { label: clean(label ? label.textContent : ''), value: clean(value ? value.textContent : '') };
      });
      if (rows.length) return rows;
      return Array.prototype.slice.call(document.querySelectorAll('.tf-workout__facts > div')).map(function(row) {
        var label = row.querySelector('span');
        var value = row.querySelector('strong');
        return { label: clean(label ? label.textContent : ''), value: clean(value ? value.textContent : '') };
      });
    }
    function factValue(rows, names) {
      var match = rows.find(function(row) { return names.indexOf(row.label.toLowerCase()) > -1; });
      return match ? match.value : '—';
    }
    function getWorkoutDays() {
      return Array.prototype.slice.call(document.querySelectorAll('.tf-workout__description #workout table.gainscss')).map(function(table) {
        var day = clean((table.querySelector('thead th') || {}).textContent || 'Workout day');
        var group = '';
        var rows = [];
        Array.prototype.slice.call(table.querySelectorAll('tbody tr')).forEach(function(row) {
          var cells = Array.prototype.slice.call(row.cells).map(function(cell) { return clean(cell.textContent); });
          if (!cells.length) return;
          if (cells.length === 1 && cells[0].toLowerCase() !== 'exercise') { group = cells[0]; return; }
          if (cells[0].toLowerCase() === 'exercise') return;
          if (cells.length >= 3) rows.push([cells[0], cells[1], cells[2]]);
        });
        return { day: day, group: group, rows: rows };
      }).filter(function(day) { return day.rows.length; });
    }
    function drawFooter(doc) {
      var h = doc.internal.pageSize.getHeight();
      doc.setFillColor(0, 0, 0); doc.rect(0, h - 17, 215.9, 3, 'F');
      doc.setFillColor(255, 69, 0); doc.rect(0, h - 14, 215.9, 10, 'F');
      doc.setFillColor(0, 0, 0); doc.rect(0, h - 4, 215.9, 4, 'F');
      doc.setFont('helvetica', 'bold'); doc.setFontSize(8.5); doc.setTextColor(255, 255, 255);
      doc.text("TIGER FITNESS  |  YOU'RE MORE THAN JUST A NUMBER HERE", 108, h - 7.5, { align: 'center' });
    }
    function drawHero(doc, title, intro) {
      doc.setFillColor(0, 0, 0); doc.rect(0, 0, 215.9, 48, 'F');
      doc.setFillColor(255, 69, 0); doc.rect(0, 45, 215.9, 3, 'F');
      doc.setFont('helvetica', 'bold'); doc.setFontSize(12); doc.setTextColor(255, 255, 255); doc.text('TIGER', 12, 13);
      doc.setTextColor(255, 69, 0); doc.text('FITNESS', 36, 13);
      doc.setFontSize(6.5); doc.setTextColor(255, 179, 145); doc.text('ADVANCED STRENGTH & PERFORMANCE PLAN', 12, 20);
      doc.setFontSize(18); doc.setTextColor(255, 255, 255); doc.text(doc.splitTextToSize(title.toUpperCase(), 130), 12, 29, { lineHeightFactor: 1.05 });
      if (intro) { doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5); doc.setTextColor(232, 232, 232); doc.text(doc.splitTextToSize(intro, 130), 12, 39, { lineHeightFactor: 1.2 }); }
      doc.setFont('helvetica', 'bold'); doc.setFontSize(16); doc.setTextColor(255, 69, 0); doc.text('TF', 190, 23, { align: 'center' });
      doc.setFontSize(7); doc.setTextColor(255, 255, 255); doc.text('TIGER FITNESS', 190, 29, { align: 'center' });
    }
    function drawStats(doc, rows) {
      var cards = [
        ['MAIN GOAL', factValue(rows, ['main goal', 'goal'])],
        ['PROGRAM LENGTH', factValue(rows, ['program duration', 'duration'])],
        ['TRAINING SCHEDULE', factValue(rows, ['days per week', 'frequency'])],
        ['SESSION TIME', factValue(rows, ['time per workout'])],
        ['EXPERIENCE LEVEL', factValue(rows, ['training experience', 'level'])],
        ['WORKOUT TYPE', factValue(rows, ['workout type'])],
        ['EQUIPMENT', factValue(rows, ['equipment needed', 'equipment'])],
        ['TARGETED ATHLETE', factValue(rows, ['targeted gender'])]
      ];
      var x = 12, y = 56, width = 48, height = 27;
      cards.forEach(function(card, index) {
        var col = index % 4, row = Math.floor(index / 4), cardX = x + col * width, cardY = y + row * height;
        doc.setFillColor(247, 247, 247); doc.rect(cardX, cardY, width, height, 'F');
        doc.setDrawColor(224, 224, 224); doc.rect(cardX, cardY, width, height, 'S');
        doc.setFont('helvetica', 'bold'); doc.setFontSize(6.6); doc.setTextColor(100, 100, 100); doc.text(card[0], cardX + 3, cardY + 7);
        doc.setFontSize(9.7); doc.setTextColor(18, 18, 18); doc.text(doc.splitTextToSize(card[1], width - 6), cardX + 3, cardY + 15, { lineHeightFactor: 1.15 });
      });
      return y + height * 2 + 8;
    }
    function drawStandard(doc, y) {
      doc.setFillColor(255, 244, 238); doc.rect(12, y, 191.9, 21, 'F'); doc.setFillColor(255, 69, 0); doc.rect(12, y, 1.6, 21, 'F');
      doc.setFont('helvetica', 'bold'); doc.setFontSize(8.2); doc.setTextColor(25, 25, 25); doc.text('EXECUTION STANDARD:', 17, y + 7);
      doc.setFont('helvetica', 'normal'); doc.setFontSize(8.1);
      var note = 'Complete a light 10–12 rep warm-up set before the first exercise each day. Follow the listed sets and reps exactly, use controlled form, and train with a qualified partner whenever the program calls for assisted negatives.';
      doc.text(doc.splitTextToSize(note, 160), 50, y + 7, { lineHeightFactor: 1.35 });
      return y + 29;
    }
    function drawDay(doc, day, y) {
      if (y > 213) { doc.addPage(); y = 14; }
      var heading = (day.day + (day.group ? ' — ' + day.group : '')).toUpperCase();
      doc.setFillColor(0, 0, 0); doc.rect(12, y, 191.9, 11, 'F');
      doc.setFont('helvetica', 'bold'); doc.setFontSize(12); doc.setTextColor(255, 255, 255); doc.text(heading, 15, y + 7.2);
      doc.autoTable({
        startY: y + 11,
        head: [['EXERCISE', 'SETS', 'REPS']],
        body: day.rows,
        margin: { left: 12, right: 12, bottom: 21 },
        theme: 'grid',
        tableLineColor: [215, 215, 215],
        tableLineWidth: .18,
        styles: { font: 'helvetica', fontSize: 8.4, cellPadding: 2.4, textColor: [25, 25, 25], lineColor: [215, 215, 215], lineWidth: .18, valign: 'middle' },
        headStyles: { fillColor: [255, 69, 0], textColor: [255, 255, 255], fontStyle: 'bold', fontSize: 7.3, halign: 'center' },
        alternateRowStyles: { fillColor: [247, 247, 247] },
        columnStyles: { 0: { cellWidth: 123, fontStyle: 'bold' }, 1: { cellWidth: 30, halign: 'center' }, 2: { cellWidth: 38.9, halign: 'center' } }
      });
      return doc.lastAutoTable.finalY + 11;
    }
    function drawCoaching(doc, y) {
      if (y > 205) { doc.addPage(); y = 18; }
      doc.setFillColor(0, 0, 0); doc.rect(0, y, 215.9, 50, 'F');
      doc.setFont('helvetica', 'bold'); doc.setFontSize(12); doc.setTextColor(255, 255, 255); doc.text('COACHING POINTS — WEEKS 1–12', 12, y + 10);
      var notes = [
        ['PROGRESSION', 'When you complete the prescribed final-set reps—or more—increase load next time while protecting form.'],
        ['REST', 'Move directly to the next exercise after your partner’s set to preserve the intended training pace.'],
        ['OFF-DAY CONDITIONING', 'Use low-volume conditioning or sprint work on non-lifting days when recovery allows.'],
        ['FUEL & RECOVERY', 'Prioritize nutrient-dense protein, quality carbohydrates, hydration and recovery throughout the plan.']
      ];
      notes.forEach(function(note, index) {
        var col = index % 2, row = Math.floor(index / 2), x = 12 + col * 97, noteY = y + 19 + row * 15;
        doc.setFont('helvetica', 'bold'); doc.setFontSize(7.2); doc.setTextColor(255, 179, 145); doc.text(note[0], x, noteY);
        doc.setFont('helvetica', 'normal'); doc.setFontSize(7.6); doc.setTextColor(238, 238, 238); doc.text(doc.splitTextToSize(note[1], 88), x, noteY + 5, { lineHeightFactor: 1.25 });
      });
    }
    function waitForPdf(ready, attempts) {
      if (window.jspdf && window.jspdf.jsPDF && window.jspdf.jsPDF.API.autoTable) { ready(); return; }
      if (attempts > 0) { window.setTimeout(function() { waitForPdf(ready, attempts - 1); }, 150); return; }
      button.disabled = false; button.textContent = 'Download Workout'; alert('The workout PDF is still loading. Please try again in a moment.');
    }
    button.addEventListener('click', function() {
      button.disabled = true; button.textContent = 'Preparing PDF…';
      waitForPdf(function() {
        try {
          var title = clean((document.querySelector('.tf-workout h1') || {}).textContent || 'Tiger Fitness Workout');
          var intro = clean((document.querySelector('.tf-workout__summary') || {}).textContent || '');
          var rows = getFactRows();
          var days = getWorkoutDays();
          var doc = new window.jspdf.jsPDF({ unit: 'mm', format: 'letter', orientation: 'portrait', compress: true });
          drawHero(doc, title, intro);
          var y = drawStats(doc, rows);
          y = drawStandard(doc, y);
          days.forEach(function(day) { y = drawDay(doc, day, y); });
          drawCoaching(doc, y);
          for (var page = 1; page <= doc.getNumberOfPages(); page++) { doc.setPage(page); drawFooter(doc); }
          doc.save(slugify(title) + '-workout.pdf');
        } catch (error) {
          alert('We could not create this workout PDF. Please try again.');
        }
        button.disabled = false; button.textContent = 'Download Workout';
      }, 30);
    });
  })();
})();
  (function() {
    var button = document.querySelector('[data-workout-download-v3]');
    if (!button) return;
    var assetsEl = document.querySelector('[data-workout-pdf-assets]');
    function absUrl(u) { return u && u.indexOf('//') === 0 ? 'https:' + u : u; }
    var LOGO = absUrl(assetsEl ? (assetsEl.getAttribute('data-logo') || '') : '');
    var FOOTER = absUrl(assetsEl ? (assetsEl.getAttribute('data-footer') || '') : '');

    var CSS = ':root{--orange:#FF4500;--ink:#222;--line:#ddd}*{box-sizing:border-box}body{margin:0;background:#e9e9e9;color:var(--ink);font-family:"Nunito Sans",Arial,sans-serif}.page{width:8.5in;margin:0 auto;background:#fff}.topbar{position:relative;min-height:205px;overflow:hidden;background:#000;color:#fff;padding:23px 34px 20px;border-bottom:7px solid var(--orange)}.brand{font-family:Montserrat,Arial,sans-serif;font-weight:900;letter-spacing:1.7px;font-size:23px;line-height:1}.brand span{color:var(--orange)}.kicker{margin-top:21px;color:#ffc0a5;font-family:Montserrat,Arial,sans-serif;font-size:10px;font-weight:800;letter-spacing:1.8px;text-transform:uppercase}h1{position:relative;z-index:1;margin:7px 0 5px;max-width:470px;font-family:Montserrat,Arial,sans-serif;font-size:30px;line-height:1.08;letter-spacing:-.7px;text-transform:uppercase}.subhead{position:relative;z-index:1;margin:0;max-width:470px;color:#e6e6e6;font-size:13px;line-height:1.4}.header-logo{position:absolute;z-index:0;right:22px;top:16px;width:210px;height:170px;object-fit:contain;object-position:right center}.main{padding:23px 34px 0}.meta{display:grid;grid-template-columns:repeat(4,1fr);gap:1px;background:#fff;border:1px solid var(--line)}.meta div{min-height:66px;padding:10px 11px;background:#f7f7f7}.meta label{display:block;color:#777;font-family:Montserrat,Arial,sans-serif;font-size:8px;font-weight:800;letter-spacing:.7px;text-transform:uppercase}.meta strong{display:block;margin-top:5px;color:#000;font-size:13px;line-height:1.15}.callout{margin:17px 0 24px;padding:13px 16px;border-left:5px solid var(--orange);background:#fff2ec;font-size:11px;line-height:1.45}.callout strong{font-family:Montserrat,Arial,sans-serif;font-size:10px;letter-spacing:.35px;text-transform:uppercase}.day{margin:0 0 22px;break-inside:avoid;page-break-inside:avoid}.dayhead{display:flex;align-items:baseline;justify-content:space-between;gap:12px;padding:10px 13px;background:#000;color:#fff}.dayhead h2{margin:0;font-family:Montserrat,Arial,sans-serif;font-size:19px;line-height:1;letter-spacing:-.25px;text-transform:uppercase}.dayhead p{margin:0;color:#ffb391;font-size:10px;font-weight:700;white-space:nowrap}table{width:100%;border-collapse:collapse;font-size:11px}th{padding:7px 10px;background:var(--orange);color:#fff;font-family:Montserrat,Arial,sans-serif;font-size:9px;letter-spacing:.6px;text-align:left;text-transform:uppercase}th:nth-child(2),th:nth-child(3),td:nth-child(2),td:nth-child(3){text-align:center}td{padding:6px 10px;border:1px solid var(--line);vertical-align:middle;line-height:1.2}tbody tr:nth-child(even) td{background:#f7f7f7}td:first-child{font-weight:700}.notes{margin:3px -34px 0;padding:17px 34px;background:#000;color:#fff}.notes h2{margin:0 0 10px;color:#fff;font-family:Montserrat,Arial,sans-serif;font-size:15px;text-transform:uppercase}.notes-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px 25px}.notes p{margin:0;color:#e9e9e9;font-size:10px;line-height:1.4}.notes strong{color:#ffb391;text-transform:uppercase;font-family:Montserrat,Arial,sans-serif;font-size:8.5px;letter-spacing:.55px}.brand-footer{margin:0 -34px;line-height:0;break-inside:avoid;page-break-inside:avoid}.brand-footer img{display:block;width:100%;height:auto}@page{size:letter;margin:0}@media print{body{background:#fff}.page{width:100%;margin:0}}';

    function clean(v) { return (v || '').replace(/\s+/g, ' ').trim(); }
    function slug(v) { return clean(v).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'tiger-fitness-workout'; }
    function esc(v) { return (v || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

    function getFactRows() {
      var rows = Array.prototype.slice.call(document.querySelectorAll('.tf-workout-summary dl > div')).map(function(row) {
        var l = row.querySelector('dt'), d = row.querySelector('dd');
        return { label: clean(l ? l.textContent : ''), value: clean(d ? d.textContent : '') };
      });
      if (rows.length) return rows;
      return Array.prototype.slice.call(document.querySelectorAll('.tf-workout__facts > div')).map(function(row) {
        var l = row.querySelector('span'), d = row.querySelector('strong');
        return { label: clean(l ? l.textContent : ''), value: clean(d ? d.textContent : '') };
      });
    }
    function factValue(rows, names) {
      var m = rows.find(function(r) { return names.indexOf(r.label.toLowerCase()) > -1; });
      return m ? m.value : '';
    }
    function tidyName(name) {
      var n = clean(name);
      n = n.replace(/\s*\([^)]*$/, '');
      n = n.replace(/\(\s*super\s*set\s*\)/ig, '— Superset');
      n = n.replace(/\(\s*each\s+leg\s*\)/ig, '— Each Leg');
      n = n.replace(/\(\s*each\s+way\s*\)/ig, '— Each Way');
      n = n.replace(/\(\s*each\s+arm\s*\)/ig, '— Each Arm');
      n = n.replace(/^BW\b/, 'Bodyweight').replace(/\bBW\b/g, 'Bodyweight');
      n = n.replace(/^KB\b/, 'Kettlebell').replace(/\bKB\b/g, 'Kettlebell');
      return clean(n);
    }
    function daySplit(rows) {
      var order = ['Push', 'Pull', 'Legs', 'Power', 'Carries', 'Neck', 'Core', 'Grip'];
      var found = {};
      rows.forEach(function(r) {
        var n = (r[0] || '').toLowerCase(), tag = '';
        if (/squat|leg press|leg curl|leg exten|lunge|step[- ]?up|wall sit|hip flexor|outer hip|glute|calf|rdl|hamstring/.test(n)) tag = 'Legs';
        else if (/box jump|jump|swing|clean|snatch|plyo|sprint/.test(n)) tag = 'Power';
        else if (/farmer|carry|carries/.test(n)) tag = 'Carries';
        else if (/neck/.test(n)) tag = 'Neck';
        else if (/abs|plank|core|medicine ball|med ball|sit[- ]?up|crunch|hollow/.test(n)) tag = 'Core';
        else if (/grip|gripper/.test(n)) tag = 'Grip';
        else if (/bench|press|dip|push|jerk|overhead/.test(n)) tag = 'Push';
        else if (/row|pull|curl|lat |chin|shrug|face pull/.test(n)) tag = 'Pull';
        if (tag) found[tag] = true;
      });
      return order.filter(function(t) { return found[t]; }).join(' / ');
    }
    function getDays() {
      var gs = Array.prototype.slice.call(document.querySelectorAll('.tf-workout__description #workout table.gainscss')).map(function(table) {
        var day = clean((table.querySelector('thead th') || {}).textContent || 'Workout Day');
        var group = '', rows = [];
        Array.prototype.slice.call(table.querySelectorAll('tbody tr')).forEach(function(row) {
          var cells = Array.prototype.slice.call(row.cells).map(function(c) { return clean(c.textContent); });
          if (!cells.length) return;
          if (cells.length === 1 && cells[0].toLowerCase() !== 'exercise') { group = cells[0]; return; }
          if (cells[0].toLowerCase() === 'exercise') return;
          if (cells.length >= 3) rows.push([tidyName(cells[0]), cells[1], cells[2]]);
        });
        return { day: day, group: group, rows: rows };
      }).filter(function(d) { return d.rows.length; });
      if (gs.length) return gs;
      var tabs = Array.prototype.slice.call(document.querySelectorAll('.tf-workout__description div[id^="tabs-"]')).map(function(div) {
        var table = div.querySelector('table');
        if (!table) return null;
        var heading = clean((div.querySelector('h2') || {}).textContent || 'Workout Day');
        var day = heading, group = '';
        var m = heading.match(/^(day\s*\d+)\s*[:\-–—]\s*(.+)$/i);
        if (m) { day = m[1]; group = m[2]; }
        var rows = [];
        Array.prototype.slice.call(table.querySelectorAll('tr')).forEach(function(row) {
          var cells = Array.prototype.slice.call(row.cells).map(function(c) { return clean(c.textContent); });
          if (cells.length < 3) return;
          if (cells[0].toLowerCase() === 'exercise') return;
          rows.push([tidyName(cells[0]), cells[1], cells[2]]);
        });
        return { day: day, group: group, rows: rows };
      }).filter(function(d) { return d && d.rows.length; });
      if (tabs.length) return tabs;
      return Array.prototype.slice.call(document.querySelectorAll('.tf-workout__description table')).map(function(table) {
        if ((table.className || '').indexOf('gainscss') > -1) return null;
        var day = 'Workout Day', group = '', rows = [];
        Array.prototype.slice.call(table.querySelectorAll('tr')).forEach(function(row) {
          var cells = Array.prototype.slice.call(row.cells).map(function(c) { return clean(c.textContent); });
          var filled = cells.filter(function(x) { return x; });
          if (filled.length === 1) { if (day === 'Workout Day') { day = filled[0]; } else if (!group) { group = filled[0]; } return; }
          if (!cells.length || cells[0].toLowerCase() === 'exercise') return;
          if (cells.length >= 3 && cells[0]) rows.push([tidyName(cells[0]), cells[1], cells[2]]);
        });
        return { day: day, group: group, rows: rows };
      }).filter(function(d) { return d && d.rows.length; });
    }
    function buildHtml(logoSrc, footerSrc) {
      logoSrc = logoSrc || LOGO; footerSrc = footerSrc || FOOTER;
      var title = clean((document.querySelector('.tf-workout h1') || {}).textContent || 'Tiger Fitness Workout');
      var intro = clean((document.querySelector('.tf-workout__summary') || {}).textContent || '');
      var rows = getFactRows();
      var days = getDays();
      var cards = [
        ['Main goal', factValue(rows, ['main goal', 'goal'])],
        ['Program length', factValue(rows, ['program duration', 'duration', 'program length'])],
        ['Training schedule', factValue(rows, ['days per week', 'frequency', 'training schedule'])],
        ['Session time', factValue(rows, ['time per workout', 'session time'])],
        ['Experience level', factValue(rows, ['training experience', 'level', 'experience level'])],
        ['Workout type', factValue(rows, ['workout type'])],
        ['Equipment', factValue(rows, ['equipment needed', 'equipment'])],
        ['Targeted athlete', factValue(rows, ['targeted gender', 'targeted athlete', 'targeted'])]
      ];
      var hasFacts = cards.some(function(c) { return c[1]; });
      var metaHtml = hasFacts ? cards.map(function(c) { return '<div><label>' + esc(c[0]) + '</label><strong>' + esc(c[1] || '—') + '</strong></div>'; }).join('') : '';
      var daysHtml = days.map(function(d) {
        var dd = d.day, gg = d.group;
        if (/^day\s*\d/i.test(gg) && !/^day\s*\d/i.test(dd)) { var _t = dd; dd = gg; gg = _t; }
        var head = esc(dd) + (gg ? ' &mdash; ' + esc(gg) : '');
        var split = daySplit(d.rows);
        var body = d.rows.map(function(r) { return '<tr><td>' + esc(r[0]) + '</td><td>' + esc(r[1]) + '</td><td>' + esc(r[2]) + '</td></tr>'; }).join('');
        return '<section class="day"><div class="dayhead"><h2>' + head + '</h2>' + (split ? '<p>' + esc(split) + '</p>' : '') + '</div>' +
          '<table><thead><tr><th>Exercise</th><th>Sets</th><th>Reps</th></tr></thead><tbody>' + body + '</tbody></table></section>';
      }).join('');
      var descEl = document.querySelector('.tf-workout__description');
      var sections = [];
      if (descEl) {
        var curSec = null;
        Array.prototype.forEach.call(descEl.children, function(node) {
          var tg = node.tagName ? node.tagName.toLowerCase() : '';
          if (tg === 'h2' || tg === 'h3') { if (curSec) sections.push(curSec); curSec = { heading: clean(node.textContent), paras: [] }; }
          else if (curSec && node.tagName && clean(node.textContent)) { curSec.paras.push(node.outerHTML); }
        });
        if (curSec) sections.push(curSec);
      }
      function secParas(names) { var s = sections.find(function(x) { return names.indexOf(x.heading.toLowerCase()) > -1; }); return s ? s.paras : []; }
      function paraText(p) { return p.replace(/^<p[^>]*>/i, '').replace(/<\/p>\s*$/i, '').replace(/<a\b[^>]*>/gi, '').replace(/<\/a>/gi, ''); }
      function joinParas(a) { return a.map(paraText).join('<br><br>'); }
      var progParas = secParas(['how to progress', 'progression', 'how to progress and adjust']);
      var warmParas = secParas(['warm-up and recovery notes', 'warm-up & recovery notes', 'warm up and recovery notes', 'warm-up and recovery', 'warm-up notes']);
      var fuelParas = secParas(['nutrition and supplementation', 'nutrition & supplementation', 'nutrition and supplements', 'fuel and recovery']);
      var calloutHtml = warmParas.length ? '<div class="callout"><strong>Execution standard:</strong> ' + paraText(warmParas[0]) + '</div>' : '';
      var noteBlocks = [];
      if (progParas.length) noteBlocks.push('<p><strong>Progression</strong><br>' + joinParas(progParas) + '</p>');
      if (warmParas.length > 1) noteBlocks.push('<p><strong>Warm-Up &amp; Recovery</strong><br>' + joinParas(warmParas.slice(1)) + '</p>');
      if (fuelParas.length) noteBlocks.push('<p><strong>Fuel &amp; Recovery</strong><br>' + joinParas(fuelParas) + '</p>');
      var notesHtml = noteBlocks.length ? '<section class="notes"><h2>Coaching Points</h2><div class="notes-grid">' + noteBlocks.join('') + '</div></section>' : '';
      var html = '<!doctype html><html lang="en"><head><meta charset="utf-8">' +
        '<meta name="viewport" content="width=device-width,initial-scale=1">' +
        '<title>' + esc(title) + ' | Tiger Fitness</title><style>' + CSS + '</style></head><body>' +
        '<div class="page"><header class="topbar">' +
        '<div class="brand">TIGER <span>FITNESS</span></div>' +
        '<div class="kicker">Tiger Fitness Workout Plan</div>' +
        '<h1>' + esc(title) + '</h1>' +
        (intro ? '<p class="subhead">' + esc(intro) + '</p>' : '') +
        (logoSrc ? '<img class="header-logo" src="' + esc(logoSrc) + '" alt="Tiger Fitness logo">' : '') +
        '</header><main class="main">' +
        (hasFacts ? '<section class="meta">' + metaHtml + '</section>' : '') +
        calloutHtml +
        daysHtml +
        notesHtml +
        (footerSrc ? '<footer class="brand-footer"><img src="' + esc(footerSrc) + '" alt="Tiger Fitness"></footer>' : '') +
        '</main></div></body></html>';
      return { html: html, title: title };
    }
    function toDataUri(u) {
      return new Promise(function(resolve) {
        if (!u) { resolve(''); return; }
        try {
          fetch(u).then(function(r) { return r.blob(); }).then(function(b) {
            var fr = new FileReader();
            fr.onloadend = function() { resolve(fr.result); };
            fr.onerror = function() { resolve(u); };
            fr.readAsDataURL(b);
          }).catch(function() { resolve(u); });
        } catch (e) { resolve(u); }
      });
    }
    button.addEventListener('click', function() {
      var original = button.textContent;
      button.disabled = true;
      button.textContent = 'Preparing...';
      Promise.all([toDataUri(LOGO), toDataUri(FOOTER)]).then(function(imgs) {
        try {
          var out = buildHtml(imgs[0], imgs[1]);
          var blob = new Blob([out.html], { type: 'text/html' });
          var url = URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = url;
          a.download = 'Tiger-Fitness-' + slug(out.title) + '.html';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          try {
            var tfPath = window.location.pathname.replace(/\/$/, '');
            var tfPayload = { article_handle: tfPath.split('/').pop(), article_title: out.title, page_path: tfPath };
            if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
              window.Shopify.analytics.publish('workout_download', tfPayload);
            }
            if (typeof window.gtag === 'function') { window.gtag('event', 'workout_download', tfPayload); }
            if (window.dataLayer && typeof window.dataLayer.push === 'function') {
              window.dataLayer.push({ event: 'workout_download', article_handle: tfPayload.article_handle, article_title: tfPayload.article_title, page_path: tfPayload.page_path });
            }
          } catch (tfErr) {}
          window.setTimeout(function() { URL.revokeObjectURL(url); }, 1500);
        } catch (error) {
          window.alert('We could not build this workout download. Please try again.');
        }
        button.disabled = false;
        button.textContent = original;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
